import React from "react";
import { Search } from "lucide-react";
import Pagination from "./Pagination";
import { fmtDate } from "../utils/inventory.helpers";

export default function ExpiredSection({
  stats,
  stockQuery,
  setStockQuery,
  loadExpired,
  loading,
  paginatedExpiredStock,
  expiredPage,
  expiredTotalPages,
  setExpiredPage,
}) {
  return (
    <>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <div className="rounded-[18px] border border-[#f2c6cc] bg-white p-5">
          <div className="text-[12px] font-semibold uppercase tracking-wide text-slate-500">
            Expired Batches
          </div>
          <div className="mt-3 text-[28px] font-bold text-slate-800">
            {stats.expiredProducts}
          </div>
        </div>

        <div className="rounded-[18px] border border-[#f2c6cc] bg-white p-5">
          <div className="text-[12px] font-semibold uppercase tracking-wide text-slate-500">
            Expired Qty
          </div>
          <div className="mt-3 text-[28px] font-bold text-slate-800">
            {stats.expiredQty}
          </div>
        </div>

        <div className="rounded-[18px] border border-[#f2c6cc] bg-white p-5">
          <div className="text-[12px] font-semibold uppercase tracking-wide text-slate-500">
            Active Products
          </div>
          <div className="mt-3 text-[28px] font-bold text-slate-800">
            {stats.totalProducts}
          </div>
        </div>

        <div className="rounded-[18px] border border-[#f2c6cc] bg-white p-5">
          <div className="text-[12px] font-semibold uppercase tracking-wide text-slate-500">
            Active Qty
          </div>
          <div className="mt-3 text-[28px] font-bold text-slate-800">
            {stats.totalAvailable}
          </div>
        </div>
      </div>

      <div className="rounded-[20px] border border-[#f2c6cc] bg-white p-5">
        <div className="flex flex-col gap-3 lg:flex-row">
          <div className="relative flex-1">
            <Search
              size={18}
              className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
            />
            <input
              value={stockQuery}
              onChange={(e) => setStockQuery(e.target.value)}
              placeholder="Search expired stock by product, SKU or batch no"
              className="h-[44px] w-full rounded-[12px] border border-[#f2c6cc] pl-11 pr-4 text-[14px] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f9dfe4]"
            />
          </div>

          <button
            type="button"
            onClick={loadExpired}
            className="inline-flex h-[44px] items-center justify-center gap-2 rounded-[12px] bg-[#d86a78] px-5 text-[14px] font-semibold text-white"
          >
            <Search size={16} />
            Apply
          </button>
        </div>
      </div>

      <div className="rounded-[20px] border border-[#f2c6cc] bg-white shadow-[0_12px_30px_rgba(216,106,120,0.08)]">
        <div className="flex items-center justify-between border-b border-[#f8dde1] px-5 py-4">
          <h3 className="text-[16px] font-bold text-slate-800">Expired Stock</h3>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[1000px]">
            <thead className="bg-[#fff7f8]">
              <tr className="text-left text-[13px] font-semibold text-slate-600">
                <th className="px-5 py-4">Product</th>
                <th className="px-5 py-4">SKU</th>
                <th className="px-5 py-4">Batch No</th>
                <th className="px-5 py-4">Expired Qty</th>
                <th className="px-5 py-4">Expiry Date</th>
                <th className="px-5 py-4">Days Expired</th>
                <th className="px-5 py-4">UOM</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="px-5 py-8 text-center text-[14px] text-slate-500">
                    Loading expired stock...
                  </td>
                </tr>
              ) : paginatedExpiredStock.length ? (
                paginatedExpiredStock.map((item, index) => (
                  <tr
                    key={`${item.product_id}-${item.batch_id || item.batch_no || index}`}
                    className="border-t border-[#f8dde1] text-[14px] text-slate-700"
                  >
                    <td className="px-5 py-4 font-semibold text-slate-800">{item.name || "-"}</td>
                    <td className="px-5 py-4">{item.sku || "-"}</td>
                    <td className="px-5 py-4">{item.batch_no || "-"}</td>
                    <td className="px-5 py-4">{Number(item.qty_available || 0)}</td>
                    <td className="px-5 py-4">{fmtDate(item.expiry_date)}</td>
                    <td className="px-5 py-4">{Number(item.days_expired || 0)}</td>
                    <td className="px-5 py-4">{item.uom || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="px-5 py-8 text-center text-[14px] text-slate-500">
                    No expired stock found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={expiredPage}
          totalPages={expiredTotalPages}
          onChange={setExpiredPage}
        />
      </div>
    </>
  );
}